import useMods from '@hooks/useMods';

import PropTypes from 'prop-types';
import React from 'react';

const CardFooter = ({ children, mods={}, mix={} }) => {
    const { className } = useMods(CardFooter, { mix, mods });

    return (
        <div
            className={ className }
        >
            { children }
        </div>
    );
};

CardFooter.displayName = 'Card__Footer';

CardFooter.propTypes = {
    children: PropTypes.node,
    mix: PropTypes.object,
    mods: PropTypes.object
};

export default CardFooter;
